<template>
  <div class="home">
    <h1>用户投诉</h1>
    <div class="complaint-form">
      <h2>投诉：</h2>
      <form @submit.prevent="submitComplaint">
        <div class="form-group">
          <textarea v-model="complaintText" placeholder="请在此处输入您的投诉（最多150个字）" class="complaint-textarea"
                    maxlength="150" required />
        </div>
        <div class="form-group">
          <textarea v-model="contactInfo" placeholder="请在此处输入您的联系方式（手机号）" class="complaint-textarea1"
                    :class="{ 'error-border': !isMobileValid && contactInfo.length > 0 }" maxlength="11" />
          <div v-if="!isMobileValid && contactInfo.length > 0" class="error-message">
            请输入正确的11位手机号
          </div>
        </div>
        <button type="submit" class="submit-btn" :disabled="!isMobileValid && contactInfo.length > 0">
          提交投诉
        </button>
      </form>
    </div>
    <div v-if="submitSuccess" class="success-message" :style="{color,backgroundColor}">
      {{ msg }}
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      VUE_APP_API_URL: process.env.VUE_APP_API_URL,
      complaintText: "",
      contactInfo: "",
      submitSuccess: false,
      msg: "投诉提交成功！我们会尽快处理您的投诉。",
      color: "#67c23a",
      backgroundColor: "#f0f9eb",
      isMobileValid: true // 手机号验证状态
    };
  },
  watch: {
    contactInfo: {
      handler(newVal) {
        this.contactInfo = newVal.replace(/\D/g, "");
        if (this.contactInfo.length === 0) {
          this.isMobileValid = true;
        } else {
          this.isMobileValid = this.validateMobilePhoneStrict(this.contactInfo);
        }
      },
      immediate: true
    }
  },
  props: {
    id: {
      type: Object,
      required: true
    }
  },
  methods: {
    submitComplaint() {
      if (!this.validateMobilePhoneStrict(this.contactInfo)) {
        this.msg = "请输入正确的手机号";
        this.color = "#f56c6c";
        this.backgroundColor = "#fef0f0";
        this.submitSuccess = true;
        setTimeout(() => {
          this.submitSuccess = false;
        }, 3000);
        return;
      }
      if (!this.complaintText.trim()) {
        this.msg = "投诉内容不能为空";
        this.color = "#f56c6c";
        this.backgroundColor = "#fef0f0";
        this.submitSuccess = true;
        setTimeout(() => {
          this.submitSuccess = false;
        }, 3000);
        return;
      }
      axios.post(`${this.VUE_APP_API_URL}/open/complaint`, {
        "id": this.id,
        "content": this.complaintText,
        "phone": this.contactInfo,
        "type": "2"
      })
        .then(response => {
          if (response.data.code === 200) {
            this.msg = response.data.msg || "投诉提交成功！我们会尽快处理您的投诉。";
            this.color = "#67c23a";
            this.backgroundColor = "#f0f9eb";
            this.submitSuccess = true;
            this.complaintText = "";
            this.contactInfo = "";
            setTimeout(() => {
              this.submitSuccess = false;
            }, 3000);
          } else {
            this.msg = response.data.msg || "提交失败，请稍后重试";
            this.color = "#f56c6c";
            this.backgroundColor = "#fef0f0";
            this.submitSuccess = true;
            setTimeout(() => {
              this.submitSuccess = false;
            }, 3000);
          }
        })
        .catch(error => {
          console.error("提交失败：", error);
          this.msg = "网络异常，请稍后重试";
          this.color = "#f56c6c";
          this.backgroundColor = "#fef0f0";
          this.submitSuccess = true;
          setTimeout(() => {
            this.submitSuccess = false;
          }, 3000);
        });
    },
    /**
     * 校验中国手机号（严格）
     * @param phone 手机号
     * @returns {boolean} 是否有效
     */
    validateMobilePhoneStrict(phone) {
      // 支持带/不带国家码（+86/0086），主体为11位手机号
      const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
      return reg.test(phone);
    }
  }
};
</script>
<style scoped>
h1 {
  color: #333;
  text-align: center;
  margin-bottom: 30px;
}

h2 {
  color: #444;
  margin-bottom: 15px;
}

.complaint-form {
  background-color: #f9f9f9;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 20px;
  position: relative;
}

.complaint-textarea {
  width: 100%;
  min-height: 150px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  resize: vertical;
}

.complaint-textarea1 {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  padding: 0 12px;
  resize: none;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  height: 40px;
  line-height: 40px;
}

.error-border {
  border-color: #f56c6c !important;
}

.error-message {
  color: #f56c6c;
  font-size: 14px;
  margin-top: 5px;
  text-align: left;
  height: 18px;
  line-height: 18px;
}

.complaint-textarea:focus, .complaint-textarea1:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 5px rgba(64, 158, 255, 0.3);
}

.submit-btn:disabled {
  background-color: #a0cfff;
  cursor: not-allowed;
}

.submit-btn {
  background-color: #409eff;
  color: white;
  border: none;
  padding: 12px 25px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-btn:hover:not(:disabled) {
  background-color: #66b1ff;
}

.success-message {
  margin-top: 20px;
  padding: 15px;
  border-radius: 4px;
  text-align: center;
}
</style>
